import {Radio} from "antd"
import {useMemo} from "react"
import {getFullName} from "helpers"
import {useModel} from "hooks"
import {Auth} from "types/auth"
import {FieldOperator, FilterList} from "types/filter"
import {AdditionalFilterContext} from "uiKit"

export type StaffScope = "mine" | "all"

type Props = AdditionalFilterContext

export function getCurrentUserStaffOption(user?: Auth.UserProfile | null) {
    const profile = user?.profiles?.[0]
    return {
        userId: user?.id,
        name: getFullName(user),
        profileId: profile?.id,
        customProfileId: profile?.customProfileId ?? user?.customUserId
    }
}

export function isMineStaffFilter(staffs: FilterList["staffs"], userId: number | string | undefined) {
    return (
        staffs?.operator === FieldOperator.Equal &&
        Array.isArray(staffs?.value) &&
        staffs.value.length === 1 &&
        String(staffs.value[0]?.userId) === String(userId)
    )
}

export function StaffMineAllShortcut({selectedFilters, search, applyFilter}: Props) {
    const model = useModel()
    const currentUserStaff = useMemo(() => getCurrentUserStaffOption(model.user), [model.user])

    const value: StaffScope = isMineStaffFilter(selectedFilters.staffs, model.user?.id) ? "mine" : "all"

    const onChange = (next: StaffScope) => {
        const nextFilters = {...selectedFilters}
        if (next === "mine") {
            nextFilters.staffs = {
                operator: FieldOperator.Equal,
                value: [currentUserStaff]
            }
        } else {
            delete nextFilters.staffs
        }
        applyFilter({selectedFilters: nextFilters, search})
    }

    return (
        <div className="flex flex-row justify-end items-center">
            <Radio.Group
                size="small"
                optionType="button"
                buttonStyle="solid"
                value={value}
                onChange={(e) => onChange(e.target.value)}>
                <Radio.Button value="mine" style={{fontSize: 15}}>
                    Mine
                </Radio.Button>
                <Radio.Button value="all" style={{fontSize: 15}}>
                    All
                </Radio.Button>
            </Radio.Group>
        </div>
    )
}
